import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { Router } from "./routes/Router";
import { Toaster } from "./components/ui";
import { useEffect } from "react";
import { applyTheme, loadTheme } from "./lib/theme";

const App = () => {
  useEffect(() => {
    const savedTheme = loadTheme();
    if (savedTheme) {
      applyTheme(savedTheme);
    }
    // uncomment this code for custom theme
    // } else {
    //   applyTheme({
    //     primary: "red",
    //     secondary: "blue",
    //     text: "blue",
    //     background: "black",
    //   });
    // }
  }, []);

  return (
    <BrowserRouter>
      <Router />
      <Toaster position="top-right" />
    </BrowserRouter>
  );
};

export default App;
